import * as React from 'react';

import { inject } from 'mobx-react';
import { IObservableArray } from 'mobx';

import { AbacusControl, AbacusExperiment, AbacusVariant } from 'bernie-abacus';
import { AnalyticsStore } from 'bernie-core';
import { LocalizedComponentProps, withLocalization } from 'bernie-l10n';

import { UitkFullscreenDialog, UitkFullscreenDialogTheme } from 'uitk-react-dialog';
import { UitkMediaGalleryImageDialog } from 'uitk-react-media-gallery';
import { ToolbarType, UitkOverlayToolbar } from 'uitk-react-toolbar';

import { GallerySwipe } from 'components/common/media/gallery-swipe';
import { MediaGallery } from 'components/common/media/media-gallery';

import { ImageViewModel } from 'models';

interface GalleryDialogProps extends LocalizedComponentProps {
  analytics?: AnalyticsStore;
  currentIndex: number;
  galleryDialogCloseCallback?: () => void;
  galleryDialogOpenCallback?: () => void;
  galleryName: string;
  images: IObservableArray<ImageViewModel> | ImageViewModel[];
  onIndexChange: (index) => void;
  trackingRfrr: string;
}

const GalleryDialogComponent = ({
  analytics,
  currentIndex,
  galleryDialogCloseCallback,
  galleryName,
  images,
  l10n,
  onIndexChange,
  trackingRfrr
}) => {
  const [showDialog, setShowDialog] = React.useState<boolean>(false);

  React.useEffect(() => {
    setShowDialog(true);
  }, []);

  const toolBarAttributes = {
    iconLabel: l10n.formatText('hotels.infosite.amenities.cancelButton.a11yLabel'),
    type: ToolbarType.CLOSE
  };

  const toolbarAnalytics = analytics.setupTracker(trackingRfrr, 'Close review gallery dialog');

  return (
    <AbacusExperiment name="PWA_UDS_Media_Gallery_Enable">
      <AbacusControl>
        <UitkFullscreenDialog dialogShow={showDialog} theme={UitkFullscreenDialogTheme.DARK} strictFullscreen={true}>
          <div className="gallery-dialog">
            <UitkOverlayToolbar {...toolBarAttributes} analytics={toolbarAnalytics} action={galleryDialogCloseCallback} />
            <section key="gallery-dialog__content" className="gallery-dialog__wrapper">
              <GallerySwipe
                galleryName={galleryName}
                images={images}
                currentIndex={currentIndex}
                onIndexChange={onIndexChange}
                enableKeyboardNavigation={true}
              />
            </section>
          </div>
        </UitkFullscreenDialog>
      </AbacusControl>
      <AbacusVariant bucket={1}>
        <UitkMediaGalleryImageDialog
          dialogShow={showDialog}
          {...toolBarAttributes}
          analytics={toolbarAnalytics}
          onDismiss={galleryDialogCloseCallback}
        >
          <MediaGallery
            images={images}
            currentIndex={currentIndex}
            galleryName={galleryName}
            analytics={analytics}
            onIndexChange={onIndexChange}
          />
        </UitkMediaGalleryImageDialog>
      </AbacusVariant>
    </AbacusExperiment>
  );
};

export const GalleryDialog = withLocalization(inject('analytics')(GalleryDialogComponent)) as React.ComponentType<GalleryDialogProps>;
